import { database } from './config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Contacto {
    constructor() {
        this.Nombre = ''
        this.Apellido = ''
        this.Correo = ''
        this.Telefono = ''
        this.Mensaje = ''
        this.Fecha = new Date()
        this.Archivo = null
        this.Producto = ''
    }

    validator(contacto) {
        if (contacto.Nombre === '') return { valid: false, message: 'Ingrese Nombre' }
        if (contacto.Apellido === '') return { valid: false, message: 'Ingrese Apellido' }
        if (contacto.Telefono === '') return { valid: false, message: 'Ingrese Teléfono' }
        if (contacto.Mensaje === '') return { valid: false, message: 'Ingrese Mensaje' }

        return { valid: true, message: '' }
    }

    enviarCorreo(contacto) {
        contacto.Fecha = new Date()
        return new Promise((resolve, reject) => {
            const validate = this.validator(contacto)
            if (!validate.valid) {
                return reject(validate)
            }

            database.collection('correos').add({
                ...contacto,
            })
                .then(resolve(contacto))
                .catch(error => {
                    Error.guardarError(error)
                    console.error(error)
                    reject(error)
                })
        })



    }

}